import { render, staticRenderFns } from "./linkDigiProductModel_Pack.vue?vue&type=template&id=b27d7762&scoped=true"
import script from "./linkDigiProductModel_Pack.vue?vue&type=script&lang=js"
export * from "./linkDigiProductModel_Pack.vue?vue&type=script&lang=js"
import style0 from "./linkDigiProductModel_Pack.vue?vue&type=style&index=0&id=b27d7762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27d7762",
  null
  
)

export default component.exports